import React, { useCallback, useState } from 'react';

import TopBar from "../components/top-bar.js";
import Screen from "../components/screen.js";
import BottomSlider from "../components/bottom-slider.js";
import { BuildingProvider } from "../state/building.js";
import OnScreenKeyboard from "../ui/keyboard.js";
import { SCREENS_FOR, HOME_FOR } from "../screens/registry.js";

import Backdrop from "../media/images/background.png";

function Home() {
    /* Who the dashboard is showing itself to. The same building records
       sit behind both, which is what lets a demo submit something as a
       resident and then watch the staff side receive it. */
    const [mode, setMode] = useState('resident');
    const [currentScreen, setCurrentScreen] = useState(HOME_FOR.resident);

    const switchMode = useCallback(next => {
        setMode(next);
        setCurrentScreen(HOME_FOR[next]);
    }, []);

    /* Tiles and "Open" buttons inside a screen jump to another screen on
       the same side. A key from the other side is ignored rather than
       leaving the rail with nothing marked. */
    const go = useCallback(screen => {
        if (SCREENS_FOR[mode].some(item => item.screen === screen)) setCurrentScreen(screen);
    }, [mode]);

    return (
        <BuildingProvider go={go}>
            <div className="kiosk">
                {/* The photograph, the drifting aurora and the vignette are one
                    fixed composition behind all three bands, so changing screen
                    never disturbs the background. */}
                <div className="kiosk__backdrop" aria-hidden="true">
                    <img src={Backdrop} alt="" />
                </div>
                <div className="kiosk__aurora" aria-hidden="true"><span /><span /></div>
                <div className="kiosk__vignette" aria-hidden="true" />

                <TopBar mode={mode} onModeChange={switchMode} />
                <Screen value={currentScreen} mode={mode} />
                <BottomSlider
                    items={SCREENS_FOR[mode]}
                    home={HOME_FOR[mode]}
                    onItemClick={setCurrentScreen}
                    selectedScreen={currentScreen}
                />

                {/* Every text field on every screen and modal types
                    through this instead of the device keyboard. */}
                <OnScreenKeyboard />
            </div>
        </BuildingProvider>
    );
}

export default Home;
